<template>
    <div class="mobile-wallets-checkout py-1">
        <div v-if="loading" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="error" size="35" width="3"></v-progress-circular>
        </div>
        <div v-else-if="!windowOpened">
            <v-text-field prepend-inner-icon="mdi-cellphone" color="error darken-1" :disabled="loading" label="رقم محفظتك" placeholder="أدخل رقم محفظة الجوال التي سيتم الدفع بها" hide-details flat v-model="walletNumber" outlined class="mb-2" /> <!-- step="any" -->
            <div class="x-small-text my-3">
                رقم محفظة الجوال هو رقم بنكيلي أو أيا كان نوع المحفظة التي ستدفع بها
            </div>
            <v-btn large depressed block color="error darken-1" @click="initPaymob" class="mt-6">
                <span>التوجه للدفع</span>
                <v-icon right style="opacity: 0.75">mdi-chevron-left</v-icon>
            </v-btn>
        </div>
        <div v-else>
            <div class="d-flex justify-center mb-2">
                <v-avatar size="40">
                    <v-icon color="strong-text" size="40">mdi-open-in-app</v-icon>
                </v-avatar>
            </div>
            <div class="text-center strong-text--text">
                <h3 class="mb-1">تم فتح نافذة الدفع</h3>
                <p>
                    يُرجى إتمام الدفع قبل العودة إلى هنا لتكتمل العملية.
                </p>
            </div>

            <div class="mt-6">
                <v-btn color="success" depressed large block @click="$emit('done')">
                    <v-icon left>mdi-check</v-icon>
                    اضغط هنا بعد إتمام الدفع
                </v-btn>
            </div>
        </div>
        <!-- <div v-else>
            <iframe :href="iframeUrl" :src="iframeUrl" width="100%" border="none" style="border: none; height: 100%; overflow-x: hidden;" :style="`min-height: ${pcOnly ? '450px' : '75vh'};`" />

            <div class="mt-3">
                <v-btn color="success" depressed block @click="$emit('done')">
                    <v-icon left>mdi-check</v-icon>
                    اضغط هنا بعد إتمام الدفع
                </v-btn>
            </div>
        </div> -->
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import debounce from 'lodash.debounce';


export default {
    props: {
        amount: {
            required: true,
        }
    },
    data(){
        return {
            loading: false,
            iframeUrl: null,
            walletNumber: '',
            windowOpened: false,
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    watch: {
        walletNumber: debounce(function (walletNumber){
            this.validateNumber(walletNumber);
        }, 100),

    },
    methods: {
        ...GlobalMethods,
        validateNumber(walletNumber){
            let number = walletNumber;
            if (number.search('201') === 0){
                number = number.replace('201', '01');
            }
            number = number.replaceAll(/[^0-9]/g, '');

            if (number !== this.walletNumber){
                this.walletNumber = number;
            }
            return number;
        },
        initPaymob(){
            if (!this.loading){
                if (this.validate()){
                    this.loading = true;
                      
                    this.$store.dispatch('createPaymobMobileWalletOrder', {amount: this.amount, wallet_number: this.walletNumber}).then(response=>{
                        this.loading = false;
                        // this.iframeUrl = response.data.iframe_url;
                        this.redirectToGatewayUrl(response.data.iframe_url);
    
                    }).catch(e=>{
                        console.error(e)
                        this.loading = false;
                        this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، حاول مرة أخرى', 'error');
                    })
                }else{
                    this.showMsg('أدخل رقم محفظة الجوال بشكل صحيح', 'error');
                }
            }
        },
        redirectToGatewayUrl(url){
            // const payWindow = window.open(url, '_system', 'location=yes,height=850,width=600,scrollbars=yes,status=yes');
            const payWindow = window.open(url, '_system');
            this.windowOpened = true;
        },
        validate(){
            this.validateNumber(this.walletNumber);

            return this.walletNumber && this.walletNumber.length === 11;
        }
    },
    mounted(){
        
    }
}
</script>

<style lang="scss">
.mobile-wallets-checkout{
    .v-messages{
        min-height: 18px!important;
    }
}
</style>